import {Footer, SurveyTable} from "../../components";


export function ListSurveyPage() {
    return (
        <div className="container-fluid mt-5 p-3">
            <SurveyTable/>
            <Footer/>
        </div>
    )
}
